import { useParams } from 'react-router';

import { useGetFAQsQuery, useGetMainPageQuery } from '@/api/endpoints/mainPages';
import { FetchDataWrapper } from '@/shared/components';

import { transformDateToCorrectFormat } from '../helpers';

import { MainFAQsPageComponent } from './MainFAQsPageComponent';

export const MainFAQsPage = () => {
  const { id } = useParams();
  const {
    data: pageData,
    isLoading: isPageLoading,
    isError: isPageDataFetchError,
  } = useGetMainPageQuery({ id: Number(id) });
  const {
    data: FAQsData,
    isLoading: areFAQsLoading,
    isFetching: areFAQsFetching,
    isError: isFAQsFetchError,
  } = useGetFAQsQuery({ id: Number(id) });

  return (
    <FetchDataWrapper
      isLoading={isPageLoading || areFAQsLoading}
      isError={isFAQsFetchError || isPageDataFetchError}
    >
      {pageData && FAQsData && (
        <MainFAQsPageComponent
          FAQsData={FAQsData}
          areFAQsFetching={areFAQsFetching}
          pageName={transformDateToCorrectFormat(pageData.created_at)}
          pageId={pageData.id}
        />
      )}
    </FetchDataWrapper>
  );
};
